import React, { useState, useEffect } from 'react';
import TeamCard from '../../../../components/main/cards/TeamCard/TeamCard';
import * as ourTeamApi from '../../../../api/services/teamApi';
import './OurTeam.css';

export default function OurTeam() {
  const [team, setTeam] = useState();

  useEffect(() => {
    async function getAll() {
      try {
        let allStaff = await ourTeamApi.getAllStaff();
        setTeam(allStaff);
      } catch (err) {
        console.log(err);
      }
    }

    getAll();
  }, []);

  return (
    <>
      <div className='team-container'>
        <div className='team-content-container'>
          <h1 className='our-team-title'>MEET THE TEAM</h1>
          <div className='our-team-cards'>
            {team &&
              team.map((t, i) => (
                <div key={i} className='team-card-container'>
                  <TeamCard
                    firstName={t.firstName}
                    lastName={t.lastName}
                    title={t.jobTitle}
                    leftDesc={t.description}
                    image={t.imageUrl}
                    link={t.janeUrl}
                  />
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
}
